module.exports = __webpack_public_path__ + "static/metalProduct-e6a99a13cb4acbefeae943be9d900e9a.jpg";